import PopupAuthItem from './popup-auth-item';

// Регулярное выражение взято из https://emailregex.com/
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default class EmailAuthItem extends PopupAuthItem {
  constructor(menu) {
    super('email', menu);
  }

  get template() {
    return `
      <button>
        <svg width="44" height="44" viewBox="0 0 44 44"><ellipse cx="22" cy="22" rx="22" ry="22" fill="#3D5B9A"></ellipse><path fill="#FFF" stroke="#FFF" stroke-width="0.25" style="transform: matrix(2, 0, 0, 2, 2, 2)" d="M16.999,4.975L16.999,4.975C16.999,4.975,16.999,4.975,16.999,4.975c-0.419-0.4-0.979-0.654-1.604-0.654H4.606c-0.584,0-1.104,0.236-1.514,0.593C3.076,4.928,3.05,4.925,3.037,4.943C3.034,4.945,3.035,4.95,3.032,4.953C2.574,5.379,2.276,5.975,2.276,6.649v6.702c0,1.285,1.045,2.329,2.33,2.329h10.79c1.285,0,2.328-1.044,2.328-2.329V6.649C17.724,5.989,17.441,5.399,16.999,4.975z M15.396,5.356c0.098,0,0.183,0.035,0.273,0.055l-5.668,4.735L4.382,5.401c0.075-0.014,0.145-0.045,0.224-0.045H15.396z M16.688,13.351c0,0.712-0.581,1.294-1.293,1.294H4.606c-0.714,0-1.294-0.582-1.294-1.294V6.649c0-0.235,0.081-0.445,0.192-0.636l6.162,5.205c0.096,0.081,0.215,0.122,0.334,0.122c0.118,0,0.235-0.041,0.333-0.12l6.189-5.171c0.099,0.181,0.168,0.38,0.168,0.6V13.351z"></path></svg>
      </button>
    `;
  }

  get popupTemplate() {
    return `
      <div class="vjs-chat-popup__background"></div>
      <div class="vjs-chat-popup__container vjs-chat-email-popup">
        <button class="vjs-chat-popup__close">
          <svg width="12" height="12" viewBox="0 0 612 670.2"><path fill="#424242" d="M345.2,335.1L603.4,44.7c9.9-9.9,9.9-27.3,0-37.2s-24.8-9.9-37.2,0L305.5,300.4L44.8,7.4C34.9-2.5,20-2.5,7.6,7.4c-9.9,9.9-9.9,27.3,0,37.2l258.2,290.5L7.6,625.6c-9.9,9.9-9.9,27.3,0,37.2s24.8,9.9,37.2,0l260.7-292.9l260.7,292.9c9.9,9.9,24.8,9.9,37.2,0c9.9-9.9,9.9-27.3,0-37.2L345.2,335.1z"></path></svg>
        </button>

        <div class="vjs-chat-popup__form-title">
          Ваш email
        </div>
        <div class="vjs-chat-popup__email">
          <input type="text" name="" placeholder="Введите email..." id="email-input-auth">
        </div>
        <div class="vjs-chat-popup__button">
          <button disabled id="email-finish-auth">
            Отправить
          </button>
        </div>
      </div>
    `;
  }

  // Элемент, при нажатии на который инициируется процесс авторизации
  get authEl() {
    if (!this._authEl) {
      this._authEl = this.popupEl.querySelector('#email-finish-auth');;
    }
    return this._authEl;
  }

  get emailInputEl() {
    if (!this._emailInputEl) {
      this._emailInputEl = this.popupEl.querySelector('#email-input-auth');
    }
    return this._emailInputEl;
  }

  get eventData() {
    let eventData = super.eventData;
    eventData.authData = {
      email: this.emailInputEl.value.trim()
    };
    return eventData;
  }

  _setDomListeners() {
    this.emailInputEl.addEventListener('input', () => {
      this.authEl.disabled = !(this.emailInputEl.value || '').trim().toLowerCase().match(EMAIL_REGEX);
    });
    super._setDomListeners();
  }
}
